import { FormControl } from '@angular/forms';
import { LeadRequestType } from '@leads/shared/models/domain/lead-request.domain';
import { ScheduledAssessmentStatus, ScheduledAssessmentType } from '@leads/shared/models/domain/scheduled-assessment.domain';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownOption } from '@shared/components/forms/dropdown-control/dropdown-control.component';

export enum AssessmentScheduleSteps {
	ASSIGN_EMPLOYEE = 'assign-employee',
	ASSIGNMENT_DETAILS = 'assignment-details',
	COMMUNICATIONS = 'communications',
}

export enum AssessmentScheduleViewSteps {
	ASSESSMENT_OVERVIEW = 'assessment-overview',
	COMMUNICATIONS = 'communications',
}

export interface ISchedulerForm {
	requestType: FormControl<LeadRequestType | null>;
	employeeId: FormControl<string | null>;
	selectedDate: FormControl<NgbDateStruct | null>;
	selectedStartTime: FormControl<Date | null>;
	selectedEndTime: FormControl<Date | null>;
	assessments?: FormControl<Array<string> | null>;
	assessmentType?: FormControl<ScheduledAssessmentType | null>;
	callOutFeeRands?: FormControl<number | null>;
	includeCallOutFeeComms?: FormControl<boolean | null>;
	assessmentNotes: FormControl<string | null>;
	jobDescription: FormControl<string | null>;
	whatsappNotes: FormControl<string | null>;
}

const baseLeadAssessmentStatusOptions: Array<IDropdownOption> = [
	{ id: 'requested', icon: 'bi-calendar', value: ScheduledAssessmentStatus.REQUESTED, label: 'Requested' },
	{ id: 'scheduled', icon: 'bi-calendar-check', value: ScheduledAssessmentStatus.SCHEDULED, label: 'Customer Scheduled' },
	{ id: 'declined', icon: 'bi-calendar-x', value: ScheduledAssessmentStatus.DECLINED, label: 'Customer Declined' },
	{ id: 'cancelled', icon: 'bi-x-square', value: ScheduledAssessmentStatus.CANCELLED, label: 'Cancelled' },
	{ id: 'awaiting-invoice', icon: 'bi-hourglass-split', value: ScheduledAssessmentStatus.AWAITING_INVOICE, label: 'Awaiting Invoice' },
	{ id: 'awaiting-quote', icon: 'bi-list-task', value: ScheduledAssessmentStatus.AWAITING_QUOTE, label: 'Awaiting Quote' },
	{ id: 'invoiced', icon: 'bi-receipt', value: ScheduledAssessmentStatus.INVOICED, label: 'Invoiced' },
	{ id: 'work-completed', icon: 'bi-check', value: ScheduledAssessmentStatus.WORK_COMPLETED, label: 'Work Completed' },
	{ id: 'partially-paid', icon: 'bi-cash', value: ScheduledAssessmentStatus.PARTIALLY_PAID, label: 'Partially Paid' },
	{ id: 'completed', icon: 'bi-check-circle', value: ScheduledAssessmentStatus.COMPLETED, label: 'Completed' },
];

export const leadAssessmentStatusOptions: Array<IDropdownOption> = baseLeadAssessmentStatusOptions;

const employeeAllowedStatuses = new Set<ScheduledAssessmentStatus>([
	ScheduledAssessmentStatus.CANCELLED,
	ScheduledAssessmentStatus.AWAITING_INVOICE,
	ScheduledAssessmentStatus.AWAITING_QUOTE,
	ScheduledAssessmentStatus.WORK_COMPLETED,
]);

export const leadAssessmentRestrictedStatusOptions: Array<IDropdownOption> = baseLeadAssessmentStatusOptions.map((option) => ({
	...option,
	disabled: !employeeAllowedStatuses.has(option.value),
}));
